import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const pains = ['Cancelaste planes por el dolor sin poder explicar bien por qué.', 'Tomaste 3 ibuprofeno 600 juntos rezando que hicieran efecto.', "Te dijeron 'es normal que duela un poco' y lo creíste por años.", 'Lloraste sola en el baño esperando que pasara.', 'Trabajás, estudiás o maternás con un dolor que nadie más ve.'];
export function PainSection() {
  return <section className="w-full bg-white py-16 px-5 flex justify-center" data-id="element-73">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-50px'
    }} className="w-full max-w-md flex flex-col gap-8" data-id="element-74">
        <h2 className="font-serif font-bold text-petroleo text-3xl leading-tight" data-id="element-75">
          ¿Te suena familiar alguna de estas situaciones?
        </h2>

        <ul className="flex flex-col gap-4" data-id="element-76">
          {pains.map((pain, index) => <motion.li key={index} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-3" data-id="element-77">
              <div className="mt-1 flex-shrink-0 bg-blush-light p-1 rounded-full" data-id="element-78">
                <ArrowRight className="w-4 h-4 text-petroleo" data-id="element-79" />
              </div>
              <p className="text-gray-700 text-base leading-snug" data-id="element-80">{pain}</p>
            </motion.li>)}
        </ul>

        <div className="bg-salvia-light border-l-4 border-salvia p-4 rounded-r-xl mt-2" data-id="element-81">
          <p className="font-serif font-bold text-petroleo text-lg" data-id="element-82">
            "Eso no es normal. Y vos no estás exagerando."
          </p>
        </div>
      </motion.div>
    </section>;
}